module.exports = __webpack_public_path__ + "img/011岳晋琛.453997a5.png";